import ProjectProperties from "./project-properties"
import {ProjectSystemType} from "../types"
import ProjectTagProperties from "./tag/tag-properties"
import ProjectPageProperties from "./page/page-properties"
import ProjectGroupProperties from "./group/group-properties"
import ProjectDefaultProperties from "./default/default-properties"
import ProjectLinkProperties from "./link/link-properties"
import ProjectEmbedProperties from "./embed/embed-properties"
import ProjectViewProperties from "./view/view-properties"
import ProjectWorkspaceProperties from "./workspace/workspace-properties"
import ProjectReportViewProperties from "./report/report-view-properties"
import ProjectSession from "../project-session"
import ProjectSectionProperties from "./section/section-properties"
import ProjectSingleViewGoalsProperties from "./productivity/goals"
import ProjectSingleViewFilesProperties from "./productivity/files"
import ProjectSingleViewMeetingsProperties from "./productivity/meetigs"
import ProjectSingleViewExpensesProperties from "./productivity/expenses"
import ProjectSingleViewChatsProperties from "./productivity/chats"
import ProjectSingleViewTasksProperties from "./productivity/tasks"
import ProjectDatabaseInternalProperties from "./database-internal/properties"
import ProjectWhiteboardProperties from "./whiteboard/whiteboard-properties"
import ProjectSingleViewTodosProperties from "./todos/todos-properties"
import ProjectSupportSystemProperties from "./support-system/properties"

export default class ProjectPropertiesFactory {

    static get(projectSystemType: ProjectSystemType, properties:any, project:ProjectSession): ProjectProperties {
        const PropertiesClass    = ProjectPropertiesFactory.getClass(projectSystemType)
        return new PropertiesClass(properties, project)
    }

    static getClass(projectSystemType:ProjectSystemType): typeof ProjectProperties {

        switch (projectSystemType) {

            case ProjectSystemType.DATABASE_INTERNAL:
                return ProjectDatabaseInternalProperties

            case ProjectSystemType.SUPPORT_SYSTEM:
                return ProjectSupportSystemProperties

            case ProjectSystemType.TAG:
                return ProjectTagProperties

            case ProjectSystemType.PAGE:
                return ProjectPageProperties

            case ProjectSystemType.WHITEBOARD:
                return ProjectWhiteboardProperties

            case ProjectSystemType.CATEGORY:
                return ProjectGroupProperties

            case ProjectSystemType.SECTION:
                return ProjectSectionProperties

            case ProjectSystemType.LINK:

                return ProjectLinkProperties

            case ProjectSystemType.EMBED:
                return ProjectEmbedProperties

            case ProjectSystemType.WORKSPACE:
                return ProjectWorkspaceProperties

            case ProjectSystemType.VIEW:
                return ProjectViewProperties

            case ProjectSystemType.REPORT_VIEW:
                return ProjectReportViewProperties

            case ProjectSystemType.SINGLE_VIEW_TODOS:
                return ProjectSingleViewTodosProperties

            case ProjectSystemType.SINGLE_VIEW_GOALS:
                return ProjectSingleViewGoalsProperties

            case ProjectSystemType.SINGLE_VIEW_FILES:
                return ProjectSingleViewFilesProperties

            case ProjectSystemType.SINGLE_VIEW_MEETINGS:
                return ProjectSingleViewMeetingsProperties

            case ProjectSystemType.SINGLE_VIEW_EXPENSES:
                return ProjectSingleViewExpensesProperties

            case ProjectSystemType.SINGLE_VIEW_CHATS:
                return ProjectSingleViewChatsProperties

            case ProjectSystemType.SINGLE_VIEW_TASK_LIST:
            case ProjectSystemType.SINGLE_VIEW_TASK_BOARD:
                return ProjectSingleViewTasksProperties

            case ProjectSystemType.FOLDER:
            case ProjectSystemType.WORKFOLDER:
            case ProjectSystemType.BACKLOG:
            case ProjectSystemType.SPRINT:
            case ProjectSystemType.PROJECT:
                return ProjectDefaultProperties

            default:
                console.warn("#kdjieury - Unknown system type = ", projectSystemType)
                return ProjectDefaultProperties
        }
    }
}
